export default {
  edit: 'Editar venta',
  section: 'Ventas para llevar',
  loading: 'Cargando ventas...',
  actions: {
    save: 'Guardar',
    create: 'Crear',
    close: 'Cerrar',
    cancel: 'Cancelar'
  },
  modals: {
    create: {
      title: 'Crear venta'
    }
  },
  labels: {
    phone: 'Teléfono',
    total: 'Monto de venta',
    status: 'Status'
  },
  headers: {
    order: 'No. de orden',
    status: 'Estatus',
    customer: 'Datos del cliente',
    total: 'Total',
    tip: 'Propina',
    fee: 'Comisión',
    updated: 'Última actualización',
    created: 'Fecha de creación',
    actions: 'Acciones'
  }
}
